<script setup>
  import {inject} from "vue";

  import {analysisTypes} from "@pages/Records/Components/Result/Enums.js";

  defineOptions({
    name: "PagesRecordResultHead",
  });

  defineProps({
    record: {
      type: Object,
      required: true,
    },
    sharedata: {
      type: Object,
      required: true,
    },
  });

  const resultConfig = inject("resultConfig");
</script>

<template>
  <section class="print:h-[3.5cm]" :data-test="getTestId('head')">
    <div class="flex items-start justify-around">
      <header class="flex flex-col items-center">
        <h2 class="text-3xl font-semibold print:font-normal">Medikationsanalyse</h2>

        <div v-if="$page.props.client.license.is_pro" class="text-md text-center md:text-lg">
          <span class="print:hidden">Analyse ({{ analysisTypes[resultConfig.analysistype] }})</span>

          <template v-if="sharedata.shared_with_me === false">
            <span v-if="$page.props.client?.company">
              <span class="print:hidden">von:</span>
              <span class="hidden print:inline">Lizenziert für</span>
              {{ $page.props.client?.company }}
            </span>

            <address class="not-italic">
              <template v-if="$page.props.client?.zip || $page.props.client?.city">
                {{ $page.props.client?.address }},
              </template>
              <template v-else>
                {{ $page.props.client?.address }}
              </template>
              {{ $page.props.client?.zip }} {{ $page.props.client?.city }}
            </address>
          </template>
        </div>
      </header>
    </div>

    <div class="mt-2 hidden text-center in-[.print-doc]:print:block">Arzt-Dokument</div>

    <div class="mt-2 hidden text-center in-[.print-patient]:print:block">Patienten-Dokument</div>

    <div class="mt-2 hidden text-center in-[.print-archive]:print:block">
      Archiv-Dokument (nur zur internen Dokumentation; alle Ergebnisse)
    </div>
  </section>
</template>
